import React from 'react';
import { Star } from 'lucide-react';

const Stars = ({ rating }) => (
  <div className="aj-stars">
    {[1, 2, 3, 4, 5].map(s => (
      <Star
        key={s}
        size={13}
        fill={s <= rating ? '#f59e0b' : '#e5e7eb'}
        color={s <= rating ? '#f59e0b' : '#e5e7eb'}
      />
    ))}
  </div>
);

export default Stars;